module.exports = __webpack_public_path__ + "static/media/logo_green.549be15c.svg";